import React from 'react'

const Info = props => (
  <svg viewBox="0 0 323 323" {...props}>
    <circle
      cx={161.5}
      cy={161.5}
      r={161.5}
      fill={props.color ? props.color : '#fff'}
    />
    <path d="M161.5 23a138.51 138.51 0 1 1-97.93 40.57A137.58 137.58 0 0 1 161.5 23m0-23A161.5 161.5 0 1 0 323 161.5 161.51 161.51 0 0 0 161.5 0z" />
    <path d="M103.84 107.56A56.62 56.62 0 0 1 127 81.64q15.48-9.12 36.36-9.12 16.8 0 29.88 5.52t20.16 15.24a35.66 35.66 0 0 1 7.08 21.48 39 39 0 0 1-3.36 16.44A53.31 53.31 0 0 1 209 144a163.37 163.37 0 0 1-13 13 166.72 166.72 0 0 0-12.48 12.36 50.06 50.06 0 0 0-7.8 12.12 36 36 0 0 0-3.24 15.36 4.1 4.1 0 0 1-4.08 4.08h-17q-4.32 0-4.32-4.8a55.16 55.16 0 0 1 3.48-20A60.69 60.69 0 0 1 159 160.6a182.22 182.22 0 0 1 13-14.6 113.84 113.84 0 0 0 13-15.36 25 25 0 0 0 4.32-14.16q0-10.08-7.32-16.08t-18.84-6a36.43 36.43 0 0 0-19.68 5.88 32.3 32.3 0 0 0-13.2 15.24 3.39 3.39 0 0 1-1.68 1.8 5.51 5.51 0 0 1-2.64.12l-20.4-5.28q-3.16-1-1.72-4.6zM177 248a5 5 0 0 1-1.32 3.84q-1.32 1.2-4.44 1.2H146.8q-4.56 0-4.56-4.32V222q0-3.84 3.36-3.84h28.32q3.12 0 3.12 3.36z" />
  </svg>
)

export default Info



// WEBPACK FOOTER //
// ./src/components/shared/info.js